import {parseInt} from 'lodash';
import PropTypes from 'prop-types';
import {Component} from 'react';
import { Container } from '@mui/material';
import IndicativeSellingPriceContainer from '../components/IndicativeSellingPriceContainer';
import SellersReservePrice from '../components/SellersReservePrice';
import connected from '../connected';
import AnalyticsGateway from '../lib/AnalyticsGateway';
import ComparablesPage from './ComparablesPage';
import FewerComparablesReason from '../components/FewerComparablesReason';
import './ComparablesPage.scss';
import './SoiComparableSalesPage.scss';

export class SoiComparableSalesPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    propertyDetail: PropTypes.object.isRequired,
    comparableSales: PropTypes.object.isRequired,
    featureFlags: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const propertyId = this.parsedPropertyId();
    AnalyticsGateway.sendEvent({
      eventName: 'View Comparable Sales',
      properties: [
        {label: 'Page', value: 'Comparable Sales'},
        {label: 'Property ID', value: propertyId}
      ]
    });
  }

  parsedPropertyId = () => {
    const {match: {params: {propertyId}}} = this.props;
    return parseInt(propertyId, 10);
  };

  render() {
    const {featureFlags} = this.props;
    const showSellersReservePrice = !!featureFlags.propertyPriceStatement;
    return (
        <ComparablesPage
            {...this.props}
            comparableType="sales"
            subComparableType="soi"
            selectedComparablesFooter={FewerComparablesReason}
        >
            <Container>
                <div className="soi-top-input">
                    <IndicativeSellingPriceContainer/>
                    {showSellersReservePrice && <SellersReservePrice/>}
                </div>
            </Container>
        </ComparablesPage>
    );
  }
}

export default connected(SoiComparableSalesPage);
